export const pubs = [
    {
        id: "soundglance",
        title: "SoundGlance: Briefing the Glanceable Cues of Web Pages for Screen Reader Users",
        year: 2019,
        authors: ["Jaeyoon Song", "Kiroong Choe", "Jaemin Jo", "Jinwook Seo"],
        coauthors: ["Jaeyoon Song", "Kiroong Choe"],
        conference: {
            full: "Extended Abstracts of the 2019 CHI Conference on Human Factors in Computing Systems",
            short: "CHI LBW 2019",
        },
        url: "https://dl.acm.org/doi/abs/10.1145/3290607.3312865",
        attrs: ["international", "conference", "poster"],
        type: "Poster",
    },
    {
        id: "oss",
        title: "What Is Needed for the Sustainable Success of Open Source Software Projects: Efficiency Analysis of Commit Production Process via Git",
        year: 2018,
        authors: ["Jaeyoon Song", "Changhee Kim"],
        journal: {
            title: "Sustainability",
            volume: 10,
            page: 3001,
            publisher: "MDPI",
        },
        url: "https://www.mdpi.com/2071-1050/10/9/3001",
        attrs: ["international", "journal", "paper"],
        type: "Journal",
    },
    {
        id: "solutionChat",
        title: "SolutionChat: Real-time Moderator Support for Chat-based Structured Discussion",
        year: 2020,
        authors: [
            "Sungchul Lee",
            "Jaeyoon Song",
            "Eunyoung Ko",
            "Jihee Kim",
            "Juho Kim",
        ],
        conference: {
            full: "Proceedings of the 2020 CHI conference on human factors in computing systems",
            short: "CHI 2020",
        },
        url: "https://doi.org/10.1145/3313831.3376609",
        attrs: ["international", "conference", "paper"],
        type: "Conference",
    },
    {
        id: "talkingBoogie",
        title: "TalkingBoogie: Collaborative Mobile AAC System for Non-verbal Children with Developmental Disabilities and Their Caregivers",
        year: 2020,
        authors: [
            "Donghoon Shin",
            "Jaeyoon Song",
            "Seokwoo Song",
            "Jisoo Park",
            "Joonhwan Lee",
            "Soojin Jun",
        ],
        conference: {
            full: "Proceedings of the 2020 CHI conference on human factors in computing systems",
            short: "CHI 2020",
        },
        url: "https://dl.acm.org/doi/10.1145/3313831.3376154",
        attrs: ["international", "conference", "paper"],
        type: "Conference",
    },
    {
        id: "minglr",
        title: "Online Mingling: Supporting Ad Hoc, Private Conversations at Virtual Conferences",
        year: 2021,
        authors: ["Jaeyoon Song", "Christoph Riedl", "Thomas W. Malone"],
        conference: {
            full: "Proceedings of the 2021 CHI Conference on Human Factors in Computing Systems",
            short: "CHI 2021",
        },
        url: "https://dl.acm.org/doi/10.1145/3411764.3445776",
        attrs: ["international", "conference", "paper"],
        type: "Conference",
    },
    {
        id: "test",
        title: "A Test for Evaluating Performance in Human-Computer Systems",
        year: 2022,
        authors: [
            "Andres Campero",
            "Michelle Vaccaro",
            "Jaeyoon Song",
            "Haoran Wen",
            "Abdullah Almaatouq",
            "Thomas W. Malone",
        ],
        preprint: "arXiv preprint arXiv:2206.12390",
        coauthors: ["Andres Campero", "Michelle Vaccaro"],
        url: "https://arxiv.org/pdf/2206.12390",
        attrs: ["international", "preprint"],
        type: "Preprint",
    },
    {
        id: "who2chat",
        title: "Who2chat: A Social Networking System for Academic Researchers in Virtual Social Hours Enabling Coordinating, Overcoming Barriers and Social Signaling",
        year: 2024,
        authors: [
            "Soya Park",
            "Jaeyoon Song",
            "David Karger",
            "Thomas W. Malone",
        ],
        journal: {
            short: "CSCW 2024",
            title: "Proceedings of the ACM on Human-Computer Interaction",
            volume: 8,
            page: "1--34",
            publisher: "ACM New York, NY, USA",
        },
        url: "https://doi.org/10.1145/3637435",
        attrs: ["international", "journal", "paper"],
        type: "Journal",
    },
    {
        id: "togedule",
        title: "Togedule: Scheduling Meetings with Large Language Models and Adaptive Representations of Group Availability",
        year: 2025,
        authors: ["Jaeyoon Song", "Zahra Ashktorab", "Thomas W. Malone"],
        journal: {
            short: "CSCW 2025",
            title: "Proceedings of the ACM on Human-Computer Interaction",
            // volume: 8,
            // page: "1--34",
            publisher: "ACM New York, NY, USA",
        },
        url: "https://arxiv.org/abs/2505.01000",
        link: "/project/togedule",
        attrs: ["international", "journal", "paper"],
        type: "Journal",
        upcoming: true,
    },
    {
        id: "ibm",
        title: "Interaction Configurations and Prompt Guidance in Conversational AI for Question Answering in Human-AI Teams",
        year: 2025,
        authors: [
            "Jaeyoon Song",
            "Zahra Ashktorab",
            "Qian Pan",
            "Casey Dugan",
            "Werner Geyer",
            "Thomas W. Malone",
        ],
        journal: {
            short: "CSCW 2025",
            title: "Proceedings of the ACM on Human-Computer Interaction",
            // volume: 8,
            // page: "1--34",
            publisher: "ACM New York, NY, USA",
        },
        url: "https://arxiv.org/abs/2505.01648",
        link: "/project/ibm",
        attrs: ["international", "journal", "paper"],
        type: "Journal",
        upcoming: true,
    },
    // {
    //     id: "forecasting",
    //     title: "Investigating the Forecasting Capabilities of Large Language Models",
    //     year: 2025,
    //     authors: [],
    //     // url: "https://arxiv.org/abs/2206.12390",
    //     link: "/project/forecasting",
    //     conference: {
    //         title: "Work In Progress",
    //     },
    //     attrs: ["international", "journal", "wip"],
    //     type: "WIP",
    // },
    {
        id: "story",
        title: "How Human-AI Synergy Changes as AI Technology Advances: A Case of Writing Short Stories",
        year: 2025,
        authors: [
            "Jaeyoon Song",
            "Jennifer Heyman",
            "Michelle Vaccaro",
            "Alice Cai",
            "Abdullah Almaatouq",
            "Thomas W. Malone",
        ],
        // authors: [],
        // url: "https://arxiv.org/abs/2206.12390",
        link: "/project/story",
        conference: {
            title: "Work In Progress",
        },
        attrs: ["international", "journal", "wip"],
        type: "WIP",
    },
    {
        id: "forecasting",
        title: "Forecasting with LLMs: A Dataset for Rapid Backtesting Without Temporal Contamination",
        year: 2025,
        authors: [
            "Jaeyoon Song",
            "Benjamin Lira Luttges",
            "Mohammed Alsobay",
            "Dan Goldstein",
        ],
        coauthors: ["Jaeyoon Song", "Benjamin Lira Luttges"],
        // url: "https://arxiv.org/abs/2206.12390",
        link: "/project/forecasting",
        conference: {
            title: "Under Review",
        },
        attrs: ["international", "conference", "manuscript"],
        type: "WIP",
    },
    {
        id: "badge",
        title: "The Generative AI Divide: A Descriptive Analysis of Heterogeneous Adaptation Among Knowledge Contributors",
        year: 2025,
        authors: [
            "Jaeyoon Song",
            "Arman Vossoughi",
            "Hongzun Zhang",
            "Dokyun Lee",
        ],
        coauthors: ["Arman Vossoughi", "Hongzun Zhang"],
        // url: "https://arxiv.org/abs/2206.12390",
        link: "/project/badge",
        conference: {
            title: "Under Revision",
        },
        attrs: ["international", "journal", "manuscript"],
        type: "WIP",
    },
    // {
    //     id: "noteworthy",
    //     title: "Designing for Effortful AI: The Efficiency-Learning Dilemma in AI-Assisted Note-Taking",
    //     year: 2025,
    //     authors: ["Jaeyoon Song", "Soya Park", "Thomas W. Malone"],
    //     // url: "https://arxiv.org/abs/2206.12390",
    //     link: "/project/noteworthy",
    //     conference: {
    //         title: "Under Review",
    //     },
    //     attrs: ["international", "conference", "manuscript"],
    //     type: "WIP",
    // },
    // {
    //     id: "uplift",
    //     title: "The Case for Harmful Capability Uplift: Why AI Safety Evaluation Must Focus on Human-AI Systems",
    //     year: 2025,
    //     authors: [
    //         "Michelle Vaccaro",
    //         "Jaeyoon Song",
    //         "Abdullah Almaatouq",
    //         "Michiel A. Bakker",
    //     ],
    //     url: "https://miba.dev/assets/publications/2025_hcu/harmful_capability_uplift.pdf",
    //     link: "/project/uplift",
    //     conference: {
    //         title: "Work In Progress",
    //     },
    //     attrs: ["international", "journal", "wip"],
    //     type: "WIP",
    // },
];
